import React from "react";
import { Lightbox, LightboxTrigger, LightboxContent } from "@/components/UI/lightbox";
import { DrilldownDepthContext } from "./context/DrilldownDepthContext";
import { DrilldownLevel } from "./comps/DrilldownLevel";

export const DrilldownList = ({
  options,
  value,
  isMulti,
  isLoading,
  isFetchingNextPage,
  observerRef,
  onChange,
  onDrilldown,
  getChildLevel,
  genCustomSelectComp,
  folderSelectionMode = "exclusive",
  baseZIndex = 100000,
  listStyle,
  emptyMessage,
  headerContent,
  showSelectedFirst,
}) => {
  const levelContent = (
    <DrilldownDepthContext.Provider value={0}>
      <DrilldownLevel
        options={options}
        value={value}
        isMulti={isMulti}
        isLoading={isLoading}
        isFetchingNextPage={isFetchingNextPage}
        observerRef={observerRef}
        onChange={onChange}
        onDrilldown={onDrilldown}
        getChildLevel={getChildLevel}
        folderSelectionMode={folderSelectionMode}
        baseZIndex={baseZIndex}
        listStyle={listStyle}
        emptyMessage={emptyMessage}
        headerContent={headerContent}
        showSelectedFirst={showSelectedFirst}
        isRoot
      />
    </DrilldownDepthContext.Provider>
  );

  if (genCustomSelectComp) {
    return (
      <Lightbox placement="bottom-start">
        <LightboxTrigger>
          {genCustomSelectComp()}
        </LightboxTrigger>
        <LightboxContent cascade style={{ zIndex: baseZIndex }}>
          {levelContent}
        </LightboxContent>
      </Lightbox>
    );
  }

  return levelContent;
};

export { DrilldownLevel } from "./comps/DrilldownLevel";
export { DrilldownDepthContext } from "./context/DrilldownDepthContext";
export { StaticDrilldownList } from "./comps/StaticDrilldownList";
export { SearchActionsToolbar, makeFilterToolbarProps } from "./comps/SearchActionsToolbar";
